// Inline media tokens embedded in note text, e.g. [media:notes-media/cat-20260709-101500.jpg]
// Tokens live inside segment text so the character-diff authorship tracking
// in noteSegments.ts treats them like any other run of characters.

export const MEDIA_TOKEN_REGEX = /\[media:([^\]]+)\]/g

export type MediaKind = 'image' | 'video'

const VIDEO_EXTENSIONS = ['mp4', 'webm', 'mov', 'm4v', 'ogv', 'avi', 'mkv']

export function makeMediaToken(key: string): string {
  return `[media:${key}]`
}

/** Every media S3 key referenced by the given text, in order of appearance */
export function extractMediaKeys(text: string): string[] {
  const keys: string[] = []
  for (const match of text.matchAll(MEDIA_TOKEN_REGEX)) {
    keys.push(match[1])
  }
  return keys
}

export function mediaKindFromKey(key: string): MediaKind {
  const ext = key.split('.').pop()?.toLowerCase() ?? ''
  return VIDEO_EXTENSIONS.includes(ext) ? 'video' : 'image'
}

/** Deterministic S3 key for a video's poster thumbnail */
export function thumbKeyFor(videoKey: string): string {
  const base = videoKey.split('/').pop()?.replace(/\.[^.]+$/, '') ?? videoKey
  return `notes-media/thumbs/${base}.jpg`
}

/** All keys whose presigned URLs a note needs: media keys plus video thumbnails */
export function urlKeysFor(mediaKeys: string[]): string[] {
  return mediaKeys.flatMap((key) =>
    mediaKindFromKey(key) === 'video' ? [key, thumbKeyFor(key)] : [key],
  )
}
